var $0b62e8a6414bc20c$exports = {};
$0b62e8a6414bc20c$exports = {
    "invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `Odabrani datum nije dostupan`,
            other: `Odabrani datumi nisu dostupni`
        })}.`
};


export {$0b62e8a6414bc20c$exports as default};
//# sourceMappingURL=hr-HR.module.js.map
